import type {
  G2Info,
  G2ProductInfo,
  IMPORT_STATE,
} from '@/features/Setting/Integrations/providers/types';
import { defaultAxios } from '@/services/index';

type G2InfoDTO = {
  alias: string;
  workspace_id: string;
  product_infos: G2ProductInfo[];
  import_state: IMPORT_STATE;
  history: Array<{
    created_at: string;
    start_date: string;
    end_date: string;
  }>;
};

const g2Service = {
  async createG2Info(
    access_token: string,
    workspaceAlias: string,
  ): Promise<G2Info> {
    const res = await defaultAxios.post<G2InfoDTO>(
      `/workspaces/${workspaceAlias}/g2/credential`,
      { access_token },
    );
    return {
      alias: res.data.alias,
      workspace_id: res.data.workspace_id,
      proudctInfos: res.data.product_infos || [],
      import_state: res.data.import_state,
      history: res.data.history || [],
    };
  },
  async getG2Info(alias: string): Promise<G2Info> {
    const res = await defaultAxios.get<G2InfoDTO>(`/workspaces/${alias}/g2/`);
    return {
      alias: res.data.alias,
      workspace_id: res.data.workspace_id,
      proudctInfos: res.data.product_infos || [],
      import_state: res.data.import_state,
      history: res.data.history || [],
    };
  },
  async importG2Feedback(
    workspaceAlias: string,
    dateRange: NullableDateRangeT,
  ) {
    const res = await defaultAxios.post(`/g2/${workspaceAlias}/import`, {
      start_date: dateRange.start_date,
      end_date: dateRange.end_date,
    });
    return res.data;
  },
  async getProudctInfos(alias: string): Promise<G2ProductInfo[]> {
    const res = await defaultAxios.get<G2ProductInfo[]>(`/g2/${alias}/product`);
    return res.data;
  },
  async pushG2ProductInfo(alias: string, info: G2ProductInfo) {
    const res = await defaultAxios.patch(`/g2/${alias}/push`, info);
    return res.data;
  },
  async pullG2ProductInfo(alias: string, info: G2ProductInfo) {
    const res = await defaultAxios.patch(`/g2/${alias}/pull`, info);
    return res.data;
  },
  async deleteG2Info(workspaceAlias: string): Promise<void> {
    await defaultAxios.delete(`/g2/${workspaceAlias}`);
  },
};

export default g2Service;
